<template>
    <component
        :is="link ? 'router-link' : 'span'"
        v-if="modelValue"
        :to="`/operators/${modelValue.id}`"
        :target="target"
    >
        <i
            v-if="showIcon"
            :class="icon"
        />
        {{ $filters.ellipsis(modelValue.full_name, 30) }}
    </component>
</template>

<script>
export default {
    name: 'Operator',
    props: {
        modelValue: Object,
        link: {
            type: Boolean,
            default: true,
        },
        target: {
            type: String,
            default: '',
        },
        showIcon: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        icon () {
            return 'fa fa-user-headset';
        },
    },
};
</script>
